import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import projectsReducer from './slices/projectsSlice';
import proposalsReducer from './slices/authSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectsReducer,
    proposals: proposalsReducer,
  },
});

export default store;
